import r from"./convertUnicodeToEmoji.js";import t from"./emojiList.js";const f=m=>t[m].map(o=>r(o));export{f as default};
//# sourceMappingURL=getGroupEmojis.js.map
